import { useEffect, useState } from "react";

  
export default function BlockVideo({ block, updateBlock }) {
    
    if(block.src == null){
        block.src = `<iframe class="embed-responsive-item" src="https://www.youtube.com/embed/dQw4w9WgXcQ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;" allowfullscreen=""></iframe>`;
    }
    const [src, setSrc] = useState(block.src);

    function handleChange(e) {
         // If the input is a plain YouTube URL, convert it to an embed iframe
         let val = e.target.value.trim();
         // Regex to match YouTube URLs
         const ytRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{11})/;
         const match = val.match(ytRegex);
         if (match && match[1]) {
             // Build embed iframe
             val = `<iframe class="embed-responsive-item" src="https://www.youtube.com/embed/${match[1]}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;" allowfullscreen=""></iframe>`;
         }
         updateBlock(block.id, 'src', val);
         setSrc(val);
    }

    return (
        <div className="flex flex-col gap-2 w-full" >
            <label className="block font-semibold mb-2 w-full"     >Video:</label>
            <div className="p-2 bg-gray-100 rounded w-full h-full">
                <textarea value={src} onChange={handleChange} className="w-full h-[300px]" />
            </div>
        </div>
    );
}
